import "./App.css";
import "./index.css";
import Main from "./main";
import { Routes, Route } from "react-router";
import Navbar from "./Components/Nav/Navbar";
import { HashRouter } from "react-router-dom";
import React, { useEffect, useState, createContext, useContext } from "react";
import ProjectPage from "./Components/projects/projectPage";
import AboutPage from "./Components/about/AboutPage";

// Theme Context
const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

function App() {
  const [isMobile, setIsMobile] = useState(false);
  const [theme, setTheme] = useState(() => {
    // Get theme from localStorage or default to 'light'
    return localStorage.getItem('theme') || 'light';
  });

  // Apply theme to document
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Flashlight effect - only on desktop
  useEffect(() => {
    if (isMobile) return;

    const flashlight = document.getElementById("flashlight");
    if (!flashlight) return;

    const flashlightRadius = 400;
    const flashlightOffset = flashlightRadius / 2;

    const handleMouseMove = (event) => {
      const { clientX, clientY } = event;
      flashlight.style.left = `${clientX - flashlightOffset}px`;
      flashlight.style.top = `${clientY - flashlightOffset}px`;
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [isMobile]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <HashRouter>
        <div id="main">
          {/* Decorative background shapes */}
          <div className="bg-shapes">
            <div className="bg-shape bg-shape-1"></div>
            <div className="bg-shape bg-shape-2"></div>
            <div className="bg-shape bg-shape-3"></div>
          </div>
          
          {!isMobile && <div className="flashlight" id="flashlight" />}
          <Navbar />
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/project/:id" element={<ProjectPage />} />
          </Routes>
        </div>
      </HashRouter>
    </ThemeContext.Provider>
  );
}

export default App;
